import React from "react";

const Testimonials = ({ t, lang }) => {
    return (
        <section className="py-5">
            <div className="container py-4">
                {/* Section Header */}
                <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                    <h2 className="fw-bold display-5 mb-3">
                        {lang === "en" ? "What Our Clients Say" : "آراء عملائنا"}
                    </h2>
                    <p className="text-muted fs-5">
                        {lang === "en"
                            ? "Don't just take our word for it - hear from our satisfied clients"
                            : "لا تأخذ كلامنا فقط - استمع إلى عملائنا الراضين"}
                    </p>
                </div>

                {/* Testimonials List */}
                <div className="row g-4 justify-content-center">

                    {/* 1 */}
                    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                        <div className="h-100 p-4 position-relative bg-card shadowP">
                            <div className="position-absolute top-0 start-0 ms-4 mt-3">
                                <i className="ri-double-quotes-l text-primary opacity-25" style={{ fontSize: "60px" }}></i>
                            </div>

                            <div className="mb-3 position-relative">
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                            </div>

                            <p className="mb-4 position-relative" style={{ zIndex: 1 }}>
                                {lang === "en"
                                    ? "Working with InnoBridge transformed our business operations. Their insights helped us achieve 40% growth."
                                    : "العمل مع InnoBridge حوّل عمليات أعمالنا وساعدنا على تحقيق نمو بنسبة 40٪."}
                            </p>

                            <div className="d-flex align-items-center gap-3 position-relative" style={{ zIndex: 1 }}>
                                <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                    <i className="ri-user-line fs-4"></i>
                                </div>
                                <div>
                                    <h6 className="mb-0 fw-bold">{lang === "en" ? "Sarah Johnson" : "سارة جونسون"}</h6>
                                    <small className="text-muted">CEO, TechStart Inc.</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 2 */}
                    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                        <div className="h-100 p-4 position-relative bg-card shadowP">
                            <div className="position-absolute top-0 start-0 ms-4 mt-3">
                                <i className="ri-double-quotes-l text-primary opacity-25" style={{ fontSize: "60px" }}></i>
                            </div>

                            <div className="mb-3 position-relative">
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                            </div>

                            <p className="mb-4 position-relative" style={{ zIndex: 1 }}>
                                {lang === "en"
                                    ? "Exceptional service! They helped us streamline our processes and scale efficiently."
                                    : "خدمة استثنائية! ساعدونا في تحسين عملياتنا والتوسع بكفاءة."}
                            </p>

                            <div className="d-flex align-items-center gap-3 position-relative" style={{ zIndex: 1 }}>
                                <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                    <i className="ri-user-line fs-4"></i>
                                </div>
                                <div>
                                    <h6 className="mb-0 fw-bold">{lang === "en" ? "Michael Chen" : "مايكل تشين"}</h6>
                                    <small className="text-muted">Director, Global Solutions</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 3 */}
                    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                        <div className="h-100 p-4 position-relative bg-card shadowP">
                            <div className="position-absolute top-0 start-0 ms-4 mt-3">
                                <i className="ri-double-quotes-l text-primary opacity-25" style={{ fontSize: "60px" }}></i>
                            </div>

                            <div className="mb-3 position-relative">
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                                <i className="ri-star-fill text-warning"></i>
                            </div>

                            <p className="mb-4 position-relative" style={{ zIndex: 1 }}>
                                {lang === "en"
                                    ? "A professional team that really cares. They exceeded our expectations."
                                    : "فريق محترف يهتم بعملائه. تجاوزوا توقعاتنا بوضوح."}
                            </p>

                            <div className="d-flex align-items-center gap-3 position-relative" style={{ zIndex: 1 }}>
                                <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                    <i className="ri-user-line fs-4"></i>
                                </div>
                                <div>
                                    <h6 className="mb-0 fw-bold">{lang === "en" ? "Robert Fox" : "روبرت فوكس"}</h6>
                                    <small className="text-muted">Founder, Creative Agency</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;